var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useState, useEffect } from 'react';
import useAdditionalParameters from '../hooks/useAdditionalParameters';
import { execJsInSdk, waitForSelector } from '../integration-utils';
import { useMessageListener } from '../hooks/useMessageListener';
import { getWindowLocationLoadCompleteEvent } from '../../../../utils/window-listeners';
import { useCheckLoadedAndShow } from '../hooks/useCheckLoadedAndShow';
function useHideAcceptCookies() {
    var _this = this;
    var hideAcceptCookies = useCallback(function (event) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!getWindowLocationLoadCompleteEvent(event))
                        return [2 /*return*/];
                    return [4 /*yield*/, waitForSelector("div[id='onetrust-banner-sdk']")];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, execJsInSdk(function () {
                            var modal = document.querySelector("div[id='onetrust-banner-sdk']");
                            // @ts-ignore
                            if (modal)
                                modal.style.display = 'none';
                        }, 'hide_accept_cookies')];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, []);
    useMessageListener(hideAcceptCookies);
}
function useClickRememberMe() {
    var _this = this;
    var clickRememberMe = useCallback(function (event) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!getWindowLocationLoadCompleteEvent(event))
                        return [2 /*return*/];
                    return [4 /*yield*/, waitForSelector("div[id='remember-device-form-view']")];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, execJsInSdk(function () {
                            var remember_device_form = document.querySelector("div[id='remember-device-form-view']");
                            // @ts-ignore
                            if (remember_device_form) {
                                var remember_device_btn = remember_device_form.querySelector('button');
                                if (remember_device_btn)
                                    remember_device_btn.click();
                            }
                        }, 'click_remember_me')];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, []);
    useMessageListener(clickRememberMe);
}
function useHideRememberMe() {
    var _this = this;
    var hideRememberMe = useCallback(function (event) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!getWindowLocationLoadCompleteEvent(event))
                        return [2 /*return*/];
                    return [4 /*yield*/, waitForSelector("input[id='user_remember_me']")];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, execJsInSdk(function () {
                            var _a, _b;
                            var checkbox = document.querySelector("input[id='user_remember_me']");
                            // @ts-ignore
                            var rememberMeDiv = (_b = (_a = checkbox === null || checkbox === void 0 ? void 0 : checkbox.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.parentElement;
                            if (rememberMeDiv) {
                                rememberMeDiv.style.display = 'none';
                            }
                        }, 'hide_remember_me')];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, []);
    useMessageListener(hideRememberMe);
}
export function useGusto() {
    var _this = this;
    useHideRememberMe();
    useHideAcceptCookies();
    useClickRememberMe();
    var _a = useState(''), csrfToken = _a[0], setCsrfToken = _a[1];
    var addAdditionalParameters = useAdditionalParameters().addAdditionalParameters;
    useEffect(function () {
        addAdditionalParameters({ csrfToken: csrfToken });
    }, [csrfToken, addAdditionalParameters]);
    var callback = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var csrf;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, execJsInSdk(function () {
                        var meta = document.querySelector("meta[name='csrf-token']");
                        // @ts-ignore
                        return (meta === null || meta === void 0 ? void 0 : meta.content) || '';
                    })];
                case 1:
                    csrf = _a.sent();
                    setCsrfToken(csrf);
                    return [2 /*return*/];
            }
        });
    }); }, []);
    useCheckLoadedAndShow(callback);
}
